module.exports = __webpack_public_path__ + "img/jury-bg-shape@dt.078e314.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/jury-bg-shape@dt.svg
// module id = kObi
// module chunks = 0 5